<template>
  <div>
    <a @click="fnShowModal()" class="p-2"
      ><i class="far fa-edit text-primary"></i
    ></a>

    <b-modal
      ref="modal"
      size="xl"
      hide-footer
      title="Referral Partners - update"
    >
      <div class="d-block">
        <form>
          <div class="row">
            <div class="col-12 col-md-4 col-lg-4">
              <div>
                <b-form-group
                  label="Select partner type"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-radio
                    v-model="partner_type"
                    :aria-describedby="ariaDescribedby"
                    name="some-radios"
                    value="p"
                    >As a partner</b-form-radio
                  >
                  <b-form-radio
                    v-model="partner_type"
                    :aria-describedby="ariaDescribedby"
                    name="some-radios"
                    value="s"
                    >As a secondary partner</b-form-radio
                  >
                </b-form-group>
                <div class="invalid-feedback" v-if="errors.partner_type">
                  {{ errors.partner_type[0] }}
                </div>
              </div>

              <div class="form-group" v-if="partner_type == 's'">
                <b-form-select
                  plain
                  autocomplete="off_parentId"
                  placeholder=" "
                  :options="getReferralPartnerDropdownList"
                  value-field="id"
                  text-field="name"
                  v-model="parent_id"
                ></b-form-select>
                <label class="floatingLabel typo__label"
                  >Referral partner (Parent)</label
                >
                <div class="invalid-feedback" v-if="errors.parent_id">
                  {{ errors.parent_id[0] }}
                </div>
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Name"
                  v-model="name"
                />
                <label class="floatingLabel" for="name"
                  >Name (for Partner / Secondary partner)</label
                >
                <div class="invalid-feedback" v-if="errors.name">
                  {{ errors.name[0] }}
                </div>
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="abn"
                  placeholder=""
                  v-model="abn"
                />
                <label class="floatingLabel" for="name">ABN</label>
              </div>
            </div>

            <!-- Address -->
            <div class="col-12 col-md-3 col-lg-3">
              <p class="fw-600 fs-100 text-info">Address</p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="street"
                  placeholder=" "
                  autocomplete="off_street"
                  v-model="street"
                />
                <label class="floatingLabel" for="street">St. address</label>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="suburb"
                  placeholder=" "
                  autocomplete="off_suburb"
                  v-model="suburb"
                />
                <label class="floatingLabel" for="suburb">Suburb</label>
                <div class="invalid-feedback" v-if="errors.suburb">
                  {{ errors.suburb[0] }}
                </div>
              </div>
              <div class="form-group">
                <b-form-select
                  plain
                  :options="optionStates"
                  value-field="item"
                  text-field="name"
                  placeholder=" "
                  autocomplete="off_state"
                  v-model="state"
                ></b-form-select>
                <label class="floatingLabel" for="state">State</label>
                <div class="invalid-feedback" v-if="errors.state">
                  {{ errors.state[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="postCode"
                  placeholder=" "
                  autocomplete="off_postCode"
                  v-model="postCode"
                />
                <label class="floatingLabel" for="postCode">Post code</label>
                <div class="invalid-feedback" v-if="errors.postCode">
                  {{ errors.postCode[0] }}
                </div>
              </div>
            </div>
            <!-- Rates -->
            <div class="col-12 col-md-5 col-lg-5">
              <p class="fw-600 fs-100 text-info">Rates</p>
              <div class="row">
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="interest_rate"
                      placeholder="interest_rate"
                      v-model="interest_rate"
                    />
                    <label class="floatingLabel" for="name"
                      >Interest rate</label
                    >
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="package_mgt_fee"
                      placeholder="Package mgt fee"
                      v-model="package_mgt_fee"
                    />
                    <label class="floatingLabel" for="name"
                      >Package Mgt Fee</label
                    >
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="brokerage"
                      placeholder="Brokerage"
                      v-model="brokerage"
                    />
                    <label class="floatingLabel" for="name">Brokerage</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="lease_co_fee"
                      placeholder="Lease Co Fee"
                      v-model="lease_co_fee"
                    />
                    <label class="floatingLabel" for="name">Lease Co Fee</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="vsa_fee"
                      placeholder="VSA Fee"
                      v-model="vsa_fee"
                    />
                    <label class="floatingLabel" for="name">VSA Fee</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="stamp_duty"
                      placeholder="Stamp Duty"
                      v-model="stamp_duty"
                    />
                    <label class="floatingLabel" for="name">Stamp Duty</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="registration"
                      placeholder="Registration"
                      v-model="registration"
                    />
                    <label class="floatingLabel" for="name">Registration</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="reporting_commission"
                      placeholder="Partner Reporting Commission"
                      v-model="reporting_commission"
                    />
                    <label class="floatingLabel" for="name"
                      >Partner Reporting Commission</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- web info -->
            <div class="col-12 col-md-6 col-lg-6">
              <p class="fw-600 fs-100 text-info">Web Info</p>
              <div class="row mb-3">
                <div class="col-12 col-md-12 col-lg-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="domain_name"
                      placeholder="Domain Name"
                      v-model="domain_name"
                    />
                    <label class="floatingLabel" for="name">Domain Name</label>
                  </div>

                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="web_url"
                      placeholder="Web url"
                      v-model="web_url"
                    />
                    <label class="floatingLabel" for="name">Web url</label>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="primary_color"
                      placeholder="Primary color"
                      v-model="primary_color"
                    />
                    <label class="floatingLabel" for="name"
                      >Primary color</label
                    >
                  </div>
                </div>

                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="secondary_color"
                      placeholder="Secondary color"
                      v-model="secondary_color"
                    />
                    <label class="floatingLabel" for="name"
                      >Secondary color</label
                    >
                  </div>
                </div>

                <div class="col-12 col-md-12 col-lg-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="logo_url"
                      placeholder="Logo url"
                      disabled
                      v-model="logo_url"
                    />
                    <label class="floatingLabel" for="name">Logo url</label>
                  </div>
                </div>
                <div class="col-12 col-md-12 col-lg-12">
                  <!-- <label for="name"></label> -->
                  <div class="sits-file-upload">
                    <input
                      type="file"
                      id="actual-btn"
                      ref="file"
                      @change="uploadFile"
                      hidden
                    />
                    <!-- our custom upload button -->
                    <label class="upload-label" for="actual-btn"
                      ><i class="fas fa-cloud-upload-alt text-primary"></i>
                      Upload Logo</label
                    >

                    <!-- name of file chosen -->
                    <span v-if="logo.name" id="file-chosen">{{
                      logo.name
                    }}</span>
                    <span v-else-if="web_url" id="file-chosen"
                      ><a :href="`${web_url}`" target="_blank">Logo</a></span
                    >
                    <span id="file-chosen" v-else>No file chosen</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Bank details -->
            <div class="col-12 col-md-6 col-lg-6">
              <p class="fw-600 fs-100 text-info">Bank Info</p>
              <div class="row">
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="bsb"
                      placeholder=""
                      v-model="bsb"
                    />
                    <label class="floatingLabel" for="name">BSB</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="account_number"
                      placeholder=""
                      v-model="account_number"
                    />
                    <label class="floatingLabel" for="name"
                      >Account number</label
                    >
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="account_name"
                      placeholder=""
                      v-model="account_name"
                    />
                    <label class="floatingLabel" for="name">Account name</label>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder=" "
                      autocomplete="off_phone"
                      v-model="account_full_name"
                    />
                    <label class="floatingLabel" for="suburb"
                      >Account contact full name</label
                    >
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder=" "
                      autocomplete="off_email"
                      v-model="account_email"
                    />
                    <label class="floatingLabel" for="email"
                      >Account contact email</label
                    >
                  </div>
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder=" "
                      autocomplete="off_account_second_email"
                      v-model="account_second_email"
                    />
                    <label class="floatingLabel" for="account_second_email"
                      >Account contact secondary email</label
                    >
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder=" "
                      autocomplete="off_phone"
                      v-model="account_phone"
                    />
                    <label class="floatingLabel" for="suburb"
                      >Account contact phone</label
                    >
                  </div>
                </div>

                <div class="col-12 com-md-6 col-lg-6 mt-3">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="status"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0"
                  >
                    Status
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>

          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnUpdate()"
              class="btn btn-success btn-sm"
            >
              <b-spinner v-if="isSpinner" small class="mr-2"></b-spinner>Update
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as referralPartnerService from '../../services/referralPartner.service'
export default {
  name: 'ModalReferralPartnerEdit',
  props: ['propsData'],
  components: {},
  data() {
    return {
      errors: {},
      id: '',
      partner_type: '',
      parent_id: '',
      name: '',
      street: '',
      suburb: '',
      state: '',
      postCode: '',
      interest_rate: 0,
      package_mgt_fee: 0,
      brokerage: 0,
      lease_co_fee: 0,
      vsa_fee: 0,
      stamp_duty: 0,
      registration: 0,
      reporting_commission: 0,
      domain_name: '',
      web_url: '',
      primary_color: '',
      secondary_color: '',
      logo: '',
      logo_url: '',
      account_full_name: '',
      account_email: '',
      account_second_email: '',
      account_phone: '',
      bsb: '',
      account_number: '',
      account_name: '',
      abn: '',
      status: '',
      isSpinner: false,
      optionStates: [
        { item: 'SA', name: 'South Australia' },
        { item: 'NSW', name: 'New South Wales' },
        { item: 'QLD', name: 'Queensland' },
        { item: 'TAS', name: 'Tasmania' },
        { item: 'VIC', name: 'Victoria' },
        { item: 'WA', name: 'Western Australia' },
        { item: 'NT', name: 'Northern Territory' },
        { item: 'ACT', name: 'Australian Capital Territory' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getReferralPartnerPaginateData',
      'getReferralPartnerPaginate',
      'getReferralPartnerDropdownList'
    ])
  },
  methods: {
    ...mapActions([
      'fetchReferralPartnerPaginate',
      'fetchReferralPartnerDropdownList'
    ]),
    fnShowModal() {
      this.fnGetValue(this.propsData)
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.fetchReferralPartnerDropdownList('p')
      this.$refs.modal.show()
    },

    fnGetValue(props) {
      this.id = props.id
      this.partner_type = props.partner_type
      this.parent_id = props.parent_id
      this.name = props.name
      this.street = props.street
      this.suburb = props.suburb
      this.state = props.state
      this.postCode = props.postCode
      this.interest_rate = props.interest_rate
      this.package_mgt_fee = props.package_mgt_fee
      this.brokerage = props.brokerage
      this.lease_co_fee = props.lease_co_fee
      this.vsa_fee = props.vsa_fee
      this.stamp_duty = props.stamp_duty
      this.registration = props.registration
      this.reporting_commission = props.reporting_commission
      this.domain_name = props.domain_name
      this.web_url = props.web_url
      this.primary_color = props.primary_color
      this.secondary_color = props.secondary_color
      this.logo_url = props.logo_url
      this.account_full_name = props.account_full_name
      this.account_email = props.account_email
      this.account_second_email = props.account_second_email
      this.account_phone = props.account_phone
      this.bsb = props.bsb
      this.account_number = props.account_number
      this.account_name = props.account_name
      this.abn = props.abn
      this.status = props.status
    },

    fnUpdate: async function () {
      this.isSpinner = true
      try {
        let formData = new FormData()
        formData.append('partner_type', this.partner_type)
        formData.append('parent_id', this.parent_id)
        formData.append('name', this.name)
        formData.append('street', this.street)
        formData.append('suburb', this.suburb)
        formData.append('state', this.state)
        formData.append('postCode', this.postCode)
        formData.append('interest_rate', this.interest_rate)
        formData.append('package_mgt_fee', this.package_mgt_fee)
        formData.append('brokerage', this.brokerage)
        formData.append('lease_co_fee', this.lease_co_fee)
        formData.append('vsa_fee', this.vsa_fee)
        formData.append('stamp_duty', this.stamp_duty)
        formData.append('registration', this.registration)
        formData.append('reporting_commission', this.reporting_commission)
        formData.append('domain_name', this.domain_name)
        formData.append('web_url', this.web_url)
        formData.append('primary_color', this.primary_color)
        formData.append('secondary_color', this.secondary_color)
        formData.append('logo_url', this.logo_url)
        formData.append('account_full_name', this.account_full_name)
        formData.append('account_email', this.account_email)
        formData.append('account_second_email', this.account_second_email)
        formData.append('account_phone', this.account_phone)
        formData.append('bsb', this.bsb)
        formData.append('account_number', this.account_number)
        formData.append('account_name', this.account_name)
        formData.append('abn', this.abn)
        formData.append('file', this.logo)
        formData.append('status', this.status)

        const response = await referralPartnerService.update(this.id, formData)

        this.fetchReferralPartnerPaginate(this.getReferralPartnerPaginate)
        this.hideModal()

        messageService.fnSweetAlertSuccessToast(
          'Referral Partner',
          'Updated successfully '
        )
        this.partner_type = ''
        this.parent_id = ''
        this.name = ''
        this.street = ''
        this.suburb = ''
        this.state = ''
        this.postCode = ''
        this.interest_rate = 0
        this.package_mgt_fee = 0
        this.brokerage = 0
        this.lease_co_fee = 0
        this.vsa_fee = 0
        this.stamp_duty = 0
        this.registration = 0
        this.reporting_commission = 0
        this.domain_name = ''
        this.web_url = ''
        this.primary_color = ''
        this.secondary_color = ''
        this.logo_url = ''
        this.account_full_name = ''
        this.account_email = ''
        this.account_second_email = ''
        this.account_phone = ''
        this.bsb = ''
        this.account_number = ''
        this.account_name = ''
        this.abn = ''
        this.isSpinner = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Referral Partner - Edit',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Referral Partner - Edit',
              'Something wrong'
            )
            break
        }
        this.isSpinner = false
      }
    },
    uploadFile() {
      this.logo = this.$refs.file.files[0]
    }
  }
}
</script>
